import InformationInquiry from '@components/account-info/information-inquiry';

const InformationInquiryPage = () => {
  return <InformationInquiry />;
};

export default InformationInquiryPage;
